/* components/patterns/chat/MobileChatsDrawer.jsx — полноэкранный список диалогов (xs).
   На xs нет сайдбара/гамбургера, поэтому диалоги открываются иконкой чатов в шапке
   Ассистента: поиск + список на весь экран. Переиспользует SidebarChats (единый
   источник списка диалогов); крестик закрытия даёт onClose. Портал в overlay-root. */

import React from 'react';
import ReactDOM from 'react-dom';
import { SidebarChats } from '../Sidebar.jsx';
import { getOverlayRoot } from '../../../lib/overlay.jsx';

  function MobileChatsDrawer({ open, onClose }) {
    if (!open) return null;
    return ReactDOM.createPortal(
      <div className="overlay" style={{ zIndex: 'var(--z-modal)' }}>
        <div className="overlay__backdrop" onClick={onClose} />
        <div className="chats-screen" role="dialog" aria-label="Диалоги">
          <SidebarChats onNavigate={onClose} onClose={onClose} />
        </div>
      </div>,
      getOverlayRoot()
    );
  }

export { MobileChatsDrawer };
